var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",class:{'is-info': _vm.info, 'is-selected': _vm.isSelected}},[_c('div',{staticClass:"row-fields"},[_vm._t("fields")],2),(_vm.window.is.mobile || _vm.showInfo)?_c('div',{staticClass:"row-info"},[_vm._t("info")],2):_vm._e(),_c('div',{staticClass:"row-expand"},[_vm._t("expand")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }